var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.RadarImageCanvasSource = new Class({
    Extends: OCS.Viewer.Classes.ImageCanvasSource,
    class_name: "RadarImageCanvasSource",
    active_timeout: null,
    active_radial: 0,
    options: {
        drawing_incr: 10,
        metadata: {
            source_type: 'RadarImageCanvas'
        },
        precision: null
    },

    draw_canvas: function (pixel_delta) {
        this.draw_keep = true;
        var data = this.get_data();
        /* istanbul ignore if */
        if (!data) {
            return;
        }

        var number_of_range_bins = data.num_of_rng_bins;
        var left, right, top, bottom;
        left = this.canvas_draw_args.extent[0];
        right = this.canvas_draw_args.extent[2];
        top = this.canvas_draw_args.extent[3];
        bottom = this.canvas_draw_args.extent[1];
        this.canvas_draw_args.bounds = {left: left, right: right, top: top, bottom: bottom};
        this.canvas_draw_args.width = (right - left) / this.canvas_draw_args.resolution;
        this.canvas_draw_args.height = (top - bottom) / this.canvas_draw_args.resolution;


        //find radial angle limits using in_bounds bounds. 
        var radial_extremes = this.find_radial_angle_limits();
        var extremes_cross_zero = false;
        /* istanbul ignore if */
        if (radial_extremes[0] > radial_extremes[1]) {
            extremes_cross_zero = true;
        }

        //find radial distance limits using in_bounds bounds.
        var binRange = this.findBinRange();
        if (binRange[1] > number_of_range_bins) {
            binRange[1] = number_of_range_bins;
        }

        this.active_radial = 0;
        this.draw_radial_timeout(binRange, extremes_cross_zero, radial_extremes);
        radial_extremes = [];
        binRange = [];


    },

    draw_radial_timeout: function (inBinRange, extremes_cross_zero, radial_extremes) {
        this.draw_radial_timeout_args = {bin_range: inBinRange, extremes_cross_zero: extremes_cross_zero, radial_extremes: radial_extremes};
        if (this.active_timeout) {
            clearTimeout(this.active_timeout);
            this.active_timeout = null;
        }
        this.active_timeout = setTimeout(this.draw_radial.bind(this), 0);

    },

    /**
     * Draw a radial of the radar data. Set inside of a setTimeout to allow for browser responsiveness during canvas render
     *
     * @method draw_radial
     */
    draw_radial: function () {
        this.active_timeout = null;
        var context = this.get_context();
        var inBinRange = this.draw_radial_timeout_args.bin_range;
        var extremes_cross_zero = this.draw_radial_timeout_args.extremes_cross_zero;
        var radial_extremes = this.draw_radial_timeout_args.radial_extremes;

        var data = this.get_data();
        var palette = this.get_palette();
        var scale_factor_km_per_bin = data.km_per_bin * data.scl_fctr_clc;

        var x1y1, x2y2, x3y3, x4y4, near, far, bin, bin_count, bin_start, level, angle, angle_delta, left_cos, left_sin, right_cos, right_sin;
        var util = OCS.Viewer.Functions.get_utilities();
        for (var i = this.active_radial; this.active_radial <= i + this.options.drawing_incr; this.active_radial++) {
            if (this.active_radial < data.num_of_rdls) {
                angle = data.rdl_ang_strt[this.active_radial];
                angle_delta = data.rdl_ang_dlt[this.active_radial];
                if ((!extremes_cross_zero && (angle < Math.floor(radial_extremes[0]) ||
                        angle > Math.ceil(radial_extremes[1]))) || (extremes_cross_zero && angle < Math.floor(radial_extremes[0]) && angle > Math.ceil(radial_extremes[1]))) {
                } else {
                    //make sure that we do not draw radials outside of the viewable area. The first half of this checks for when we are looking at
                    //	a bounds not crossing the east oriented 0 degree line. The second half handles when we are looking at bounds that cross that
                    //	0 degree line.

                    level = data.bin_word[this.active_radial][0];
                    bin_count = 0;
                    bin_start = 1;

                    left_cos = Math.cos(angle * util.RADIANS_PER_DEGREE);
                    left_sin = Math.sin(angle * util.RADIANS_PER_DEGREE);
                    right_cos = Math.cos((angle - angle_delta) * util.RADIANS_PER_DEGREE);
                    right_sin = Math.sin((angle - angle_delta) * util.RADIANS_PER_DEGREE);

                    for (bin = inBinRange[0]; bin <= inBinRange[1]; bin++) {
                        if ((bin !== inBinRange[1]) && (data.bin_word[this.active_radial][bin] === level)) {
                            bin_count++;
                        } else {
                            //This bin has a new value, draw the previous poly and start a new one
                            if (level !== undefined && level !== 0) {
                                x1y1 = [];
                                x2y2 = [];
                                x3y3 = [];
                                x4y4 = [];
                                near = bin_start * scale_factor_km_per_bin;
                                far = (bin_start + bin_count) * scale_factor_km_per_bin;
                                x1y1 = this.toCanvasPixel(near, left_cos, left_sin);
                                x2y2 = this.toCanvasPixel(far, left_cos, left_sin);
                                x3y3 = this.toCanvasPixel(far, right_cos, right_sin);
                                x4y4 = this.toCanvasPixel(near, right_cos, right_sin);
                                context.fillStyle = palette.get_color(level);
                                context.strokeStyle = context.fillStyle;

                                context.beginPath();
                                context.moveTo(x1y1[0], x1y1[1]);
                                context.lineTo(x2y2[0], x2y2[1]);
                                context.lineTo(x3y3[0], x3y3[1]);
                                context.lineTo(x4y4[0], x4y4[1]);
                                context.closePath();

                                context.fill();
                                context.stroke();
                            }
                            bin_start = bin;
                            bin_count = 1;
                            if (bin !== inBinRange[1]) {
                                level = data.bin_word[this.active_radial][bin];
                            }
                        }
                    }
                }
            }

        }

        /* istanbul ignore else */
        if (this.active_radial < data.num_of_rdls) {
            this.draw_radial_timeout(inBinRange, extremes_cross_zero, radial_extremes);
        } else {
            if (this.active_timeout) {
                clearTimeout(this.active_timeout);
                this.active_timeout = null;
            }
            this.active_timeout = setTimeout(function () {
                clearTimeout(this.active_timeout);
                this.active_timeout = null;
                this.drawn = true;
                this.fireEvent(OCS.Viewer.Config.events.LAYER_DRAW_FINISH, this);
                this.draw_keep = false;
                this.get_data_obj();
            }.bind(this), 0);
        }
        this.fireEvent('render');
    },

    process_nids: function () {
        if (this.palette) {
            this.palette = null;
        }
        this.get_palette();
        if (this.data_avail) {
            this.data_source_ready();
        }
    },
    beamHeight: function (inRangeKm) {
        var data = this.get_data();
        var alphaE = 8494.667; // 4/3 * earth radius
        var siteHeight = data.hght * 0.0003048; // height above sea level in km
        var tilt = data.tilt_angle;
        /* istanbul ignore if */
        if (tilt <= 0) {
            return null;
        }
        tilt *= OCS.Viewer.Functions.get_utilities().RADIANS_PER_DEGREE;
        var height = Math.sqrt(
                (inRangeKm * inRangeKm)
                + (alphaE * alphaE)
                + (2 * inRangeKm * alphaE * Math.sin(tilt))
                ) - alphaE;
        height += siteHeight;
        var heightFt = height * 3280.84;
        return {km: height, ft: heightFt};
    },
    valueFromLonLat: function (position) {
        var data = this.get_data();
        var center = {lambda: data.cntr_lmbd, phi: data.cntr_phi, lon: data.lon, lat: data.lat};

        var proj_center = ol.proj.transform([center.lon, center.lat], 'EPSG:4326', OCS.Viewer.Config.default_projection);
        var proj_position = ol.proj.transform(position, 'EPSG:4326', OCS.Viewer.Config.default_projection);
        // calculate range
        var range = this.rangeBetweenPoints(proj_center, proj_position);
        var rangeKm = range / 1000;
        var rangeMi = rangeKm * 0.621371;
        range = {km: rangeKm, mi: rangeMi};
        var util = OCS.Viewer.Functions.get_utilities();
        var lambda = position[0] * util.RADIANS_PER_DEGREE;
        var phi = position[1] * util.RADIANS_PER_DEGREE;
        var ortho = util.lonlat_to_orthographic(lambda, phi, center);

        // calculate beam height
        var beamHeight = this.beamHeight(range.km);

        // calculate angle
        var angle = Math.atan2(ortho.y, ortho.x);

        if (angle < 0) {
            angle += (2 * Math.PI);
        }
        angle *= OCS.Viewer.Functions.get_utilities().DEG_PER_RAD;

        // calculate angle index
        var angle_index, i, left, right;
        for (i = 0; i < data.num_of_rdls && typeof angle_index === 'undefined'; i++) {
            left = data.rdl_ang_strt[i];
            right = left - data.rdl_ang_dlt[i];
            /* istanbul ignore if */
            if (right < 0) { // wrap-around from 0 to 360
                right += 360;
                if (angle <= left || angle > right) {
                    angle_index = i;
                }
            } else {
                if (angle <= left && angle > right) {
                    angle_index = i;
                }
            }
        }

        // calculate bin index
        var bin_index = Math.floor((rangeKm / data.scl_fctr_clc) / data.km_per_bin);

        // determine value index
        var value_index, value_value, value_unit, value, frac;
        if (typeof angle_index !== 'undefined' && bin_index < data.num_of_rng_bins) {
            value_index = data.bin_word[angle_index][bin_index];
            value = this.index_to_value(value_index);
            value_value = value.value;
            value_unit = value.unit;
            var pal = this.get_palette();
            frac = value_index / (pal.max_index);
        }


        return {range: range, beamHeight: beamHeight, value_index: value_index, value: value_value, frac: frac, unit: value_unit, precision: this.options.precision};
    },
    radar_mode: function () {
        var data = this.get_data();
        /* istanbul ignore if */
        if (data.op_mode === 1)
            return "Clear Air";
        /* istanbul ignore if */
        if (data.op_mode === 2)
            return "Precip";
        /* istanbul ignore if */
        if (data.op_mode === 0)
            return "Maintenance";
        return "Unknown";
    },

    /**
     * Return the radial angle low and high limit. We use these numbers to accelorate the render process by limiting the amount of data we draw. 
     *
     * @method find_radial_angle_limits
     */
    find_radial_angle_limits: function () {
        var data = this.get_data();
        var center_point = {lambda: data.cntr_lmbd, phi: data.cntr_phi, lon: data.lon, lat: data.lat};
        var util = OCS.Viewer.Functions.get_utilities();
        var center = util.lonlat_to_900913(center_point.lambda, center_point.phi);

        var bounds = this.canvas_draw_args.bounds;

        //check if bounds contain the center. in that case, we do not limit by radial degrees, as we cannot.
        if (center.x < bounds.right && center.x > bounds.left && center.y < bounds.top && center.y > bounds.bottom) {
            return false;
        }
        /* istanbul ignore next */
        var x = [];
        var y = [];
        var angles = [];
        //top left corner of bounds
        x[0] = bounds.left;
        y[0] = bounds.top;

        //top right corner of bounds
        x[1] = bounds.right;
        y[1] = bounds.top;

        //bottom right corner of bounds
        x[2] = bounds.right;
        y[2] = bounds.bottom;

        //bottom left corner of bounds
        x[3] = bounds.left;
        y[3] = bounds.bottom;

        for (var i = 0; i < 4; i++) {
            //distance from center to bottom right of bounds:
            angles[i] = util.find_circle_angle(x[i], y[i], center.x, center.y);
        }

        var max_angle = Math.max.apply(Math, angles);
        var min_angle = Math.min.apply(Math, angles);
        var dlt_angle = parseFloat(max_angle) - parseFloat(min_angle);

        if (dlt_angle > 180) {
            var max_index = angles.indexOf(max_angle);
            angles.splice(max_index, 1);

            var min_index = angles.indexOf(min_angle);
            angles.splice(min_index, 1);

            min_angle = Math.max.apply(Math, angles);
            max_angle = Math.min.apply(Math, angles);
        }

        return [min_angle, max_angle];
    },
    /**
     * Return the radial distance low and high limit. We use these numbers to accelorate the render process by limiting the amount of data we draw. 
     */
    findBinRange: function () {
        var pt = [];
        var data = this.get_data();
        var center_point = {lambda: data.cntr_lmbd, phi: data.cntr_phi, lon: data.lon, lat: data.lat};
        var center = OCS.Viewer.Functions.get_utilities().lonlat_to_900913(center_point.lambda, center_point.phi);
        var radarLoc = [center.x, center.y];
        var bounds = this.canvas_draw_args.extent;

        pt.push(ol.extent.getTopLeft(bounds));
        pt.push(ol.extent.getTopRight(bounds));
        pt.push(ol.extent.getBottomRight(bounds));
        pt.push(ol.extent.getBottomLeft(bounds));
        /* istanbul ignore else */
        if (ol.extent.containsCoordinate(bounds, radarLoc)) {
            pt.push(radarLoc);
        } else {
            var otherPt = [];

            if (radarLoc[0] < bounds[0])
                otherPt[0] = bounds[0];
            else if (radarLoc[0] > bounds[2])
                otherPt[0] = bounds[2];
            else
                otherPt[0] = radarLoc[0];

            if (radarLoc[1] > bounds[3])
                otherPt[1] = bounds[3];
            if (radarLoc[1] < bounds[1])
                otherPt[1] = bounds[1];
            else
                otherPt[1] = radarLoc[1];

            pt.push(otherPt);
        }

        var distances = [];
        for (var i = 0; i < pt.length; i++) {
            //distance from center to bottom right of bounds:
            distances[i] = this.rangeBetweenPoints(radarLoc, pt[i]);
        }

        var maxDistance = Math.max.apply(Math, distances) / 1000;// / this.options.resolution;
        var minDistance = Math.min.apply(Math, distances) / 1000;

        var maxRangeBin = Math.ceil(maxDistance / data.km_per_bin);
        var minRangeBin = Math.floor(minDistance / data.km_per_bin);

        return [minRangeBin, maxRangeBin];
    },
    /**
     * Convert from radial and distance location to a canvas pixel (x,y) location
     *
     * @method toCanvasPixel
     */
    toCanvasPixel: function (r, cos_theta, sin_theta) {
        var x = r * cos_theta;
        var y = r * sin_theta;
        var data = this.get_data();
        var center = {lambda: data.cntr_lmbd, phi: data.cntr_phi, lon: data.lon, lat: data.lat};

        var projected = OCS.Viewer.Functions.get_utilities().orthographic_to_900913(x, y, center);
        // (0, 0) is top-left
        var tmpArray = [];
        tmpArray[0] = (projected.x - this.canvas_draw_args.bounds.left) / this.canvas_draw_args.resolution;
        tmpArray[1] = this.canvas_draw_args.height - ((projected.y - this.canvas_draw_args.bounds.bottom) / this.canvas_draw_args.resolution);

        return tmpArray;
    },

    /**
     * Get the value for different radar types, given the index.
     *
     * @method index_to_value
     */
    index_to_value: function (index) {
        var data = this.get_data();
        var min, value, increment, offset, unit;
        /* istanbul ignore next */
        switch (data.prod_code) {
            case 32:
            case 94:
            case 153:
            case 194:
            case 195:
                if (index === 0)
                    return {value: "Below Threshold", unit: null};
                /* istanbul ignore if */
                if (index === 1)
                    return {value: "Missing", unit: null};
                min = data.data_gate[0] / 10;
                increment = data.data_gate[1] / 10;
                return {value: (index - 2) * increment + min, unit: "dBZ"};

            case 81:
                /* istanbul ignore next */
                if (index === 0)
                    return {value: 0, unit: "dBA"};
                if (index === 255)
                    return {value: "Outside Coverage Area", unit: null};
                min = data.data_gate[0] / 10;
                increment = data.data_gate[1] / 1000;
                return {value: (index - 1) * increment + min, unit: "dBA"};

            case 93:
            case 99:
            case 154:
            case 155:
            case 199:
                /* istanbul ignore next */
                if (index === 0)
                    return {value: "Below Threshold", unit: null};
                if (index === 1)
                    return {value: "Range Folded", unit: null};
                min = data.data_gate[0] / 10;
                increment = data.data_gate[1] / 10;
                offset = (data.product_code === 155) ? 129 : 2;
                value = (index - offset) * increment + min; // m/s
                value *= 2.23694; // m/s -> mph
                value = Math.round(value * 100) / 100;
                return {value: value, unit: "mph"};

            case 134:
                /* istanbul ignore next */
                if (index === 0)
                    return {value: "Below Threshold", unit: null};
                if (index === 1)
                    return {value: "Flagged Data", unit: null};
                if (index === 254)
                    return {value: ">80", unit: "kg/m^2"};
                return {value: Math.round(this.decode_hrvil(index) * 100) / 100, unit: "kg/m^2"};

            case 135:
                /* istanbul ignore next */
                if (index === 0)
                    return {value: "Below Threshold", unit: null};
                if (index === 1)
                    return {value: "Bad Data", unit: null};
                var data_mask = data.data_gate[0];
                var data_scale = data.data_gate[1];
                var data_offset = data.data_gate[2];
                var topped_mask = data.data_gate[3];
                data = ((index & data_mask) / data_scale) - data_offset;
                var topped = (index & topped_mask) !== 0;
                value = data - 1; // The doc is a bit fuzzy, so this is a guess.
                if (topped)
                    value += "T";
                return {value: value, unit: "kft"};

            case 165:
            case 177:
                value = "UK";
                switch (index) {
                    case 0:
                        value = "Below Threshold";
                        break;
                    case 10:
                        value = "Biological (BI)";
                        break;
                    case 20:
                        value = "AP/Ground Clutter (GC)";
                        break;
                    case 30:
                        value = "Ice Crystals (IC)";
                        break;
                    case 40:
                        value = "Dry Snow (DS)";
                        break;
                    case 50:
                        value = "Wet Snow (WS)";
                        break;
                    case 60:
                        value = "Light/Mdt Rain (RA)";
                        break;
                    case 70:
                        value = "Heavy Rain (HR)";
                        break;
                    case 80:
                        value = "Big Drops (BD)";
                        break;
                    case 90:
                        value = "Graupel (GR)";
                        break;
                    case 100:
                        value = "Hail (HA)";
                        break;
                    case 140:
                        value = "Unknown (UK)";
                        break;
                    case 150:
                        value = "Range Folded";
                        break;
                    default:
                        value = "Unknown (UK)";
                        break;
                }
                return {value: value, unit: null};

            case 159:
            case 161:
            case 163:
            case 170:
            case 172:
            case 173:
            case 174:
            case 175:
            case 176:
                // The "& 0xffff" below is required because the data_gates
                // are read as sint16's rather than uint16's. The negative numbers
                // cause problems unless you mask off all but the lower 16 bits.
                var scale = this.float32((data.data_gate[0] & 0xffff) << 16 | (data.data_gate[1] & 0xffff));
                offset = this.float32((data.data_gate[2] & 0xffff) << 16 | (data.data_gate[3] & 0xffff));
                //var max_value = data.data_gate[5];
                //var leading_flags = data.data_gate[6];
                //var trailing_flags = data.data_gate[7];
                value = ((index) - offset) / scale;

                unit = null;
                switch (data.prod_code) {
                    case 159:
                        value = Math.round(value * 100) / 100;
                        unit = "dB";
                        break;
                    case 161:
                        value = Math.round(value * 100) / 100;
                        unit = null; // unitless
                        break;
                    case 163:
                        value = Math.round(value * 100) / 100;
                        unit = "Deg/km";
                        break;
                    case 170:
                    case 171:
                    case 172:
                    case 173:
                    case 174:
                    case 175:
                        value *= 0.01;
                        if (data.prod_code === 172)
                            value *= scale;
                        value = Math.round(value * 1000) / 1000;
                        unit = "in.";
                        break;
                    case 176:
                        unit = "in./hr.";
                        break;
                }

                return {value: value, unit: unit};

            case 177:
            case 138:
            case 195:
                console.log("Unimplemented");
                return {value: "?", unit: null};

            default:
                if (index > 15) {
                    console.log("ERROR - unrecognized index '" + index + "' for product type " + data.prod_code);
                    return {value: "?", unit: null};
                }
                var data_level = data.data_gate[index];
                var data_lsb = data_level & 0x00ff;
                value = "";
                if (data_level & 0x8000) {
                    switch (data_lsb) {
                        case 0:
                            value = "BLANK";
                            break;
                        case 1:
                            value = "TH";
                            break;
                        case 2:
                            value = "ND";
                            break;
                        case 3:
                            value = "RF";
                            break;
                        case 4:
                            value = "BI";
                            break;
                        case 5:
                            value = "GC";
                            break;
                        case 6:
                            value = "IC";
                            break;
                        case 7:
                            value = "GR";
                            break;
                        case 8:
                            value = "WS";
                            break;
                        case 9:
                            value = "DS";
                            break;
                        case 10:
                            value = "RA";
                            break;
                        case 11:
                            value = "HR";
                            break;
                        case 12:
                            value = "BD";
                            break;
                        case 13:
                            value = "HA";
                            break;
                            //case 14:
                        default:
                            value = "UK";
                            break;
                    }
                } else {
                    if (data_level & 0x4000)
                        value = data_lsb / 100;
                    else if (data_level & 0x2000)
                        value = data_lsb / 20;
                    else if (data_level & 0x1000)
                        value = data_lsb / 10;
                    else
                        value = data_lsb;
                }
                var prefix = "";
                if (data_level & 0x0800)
                    prefix = ">";
                else if (data_level & 0x0400)
                    prefix = "<";
                else if (data_level & 0x0200)
                    prefix = "+";
                else if (data_level & 0x0100)
                    prefix = "-";

                var final_value = (prefix === "") ? value : prefix + " " + value;

                unit = null;
                switch (data.prod_code) {
                    case 78:
                    case 79:
                    case 80:
                        unit = "in.";
                        break;
                    case 169:
                    case 171:
                        unit = "in.";
                        break;
                }

                return {value: final_value, unit: unit};
        }
    },
    decode_hrvil: function (index) {
        var data = this.get_data();
        var linear_scale = this.float16(data.data_gate[0]);
        var linear_offset = this.float16(data.data_gate[1]);
        var log_start = data.data_gate[2];
        var log_scale = this.float16(data.data_gate[3]);
        var log_offset = this.float16(data.data_gate[4]);

        if (index < log_start)
            return (index - linear_offset) / linear_scale;
        return Math.exp((index - log_offset) / log_scale);
    },
    float16: function (ieee) {
        var s = ieee >> 15;
        var e = (ieee >> 10) & 0x1f;
        var f = ieee & 0x3ff;

        if (e === 0)
            return Math.pow(-1, s) * 2 * f / 1024;
        return Math.pow(-1, s) * Math.pow(2, e - 16) * (1 + f / 1024);
    },
    float32: function (ieee) {
        var s = ieee >> 31;
        var e = (ieee >> 23) & 0xff;
        var f = ieee & 0x007fffff;

        if (e === 0 && f === 0)
            return 0;
        return Math.pow(-1, s) * Math.pow(2, e - 127) * (1 + f / (1 << 23));
    },

    get_palette_name_from_prod_code: function (prod_code) {
        var palette = "Reflectivity16Green";
        /* istanbul ignore next */
        switch (prod_code) {
            case 94:
                palette = "pal_94";
                break;

            case 99:
                palette = "pal_99";
                break;

            case 134:
                palette = "pal_134";
                break;

            case 135:
                palette = "pal_135";
                break;

            case 36:
            case 65:
            case 66:
            case 67:
            case 90:
                palette = "Reflectivity8";
                break;

            case 78:
            case 79:
            case 80:
                palette = "Reflectivity16Green";
                break;

            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 44:
            case 51:
            case 55:
            case 56:
                palette = "Velocity16";
                break;

            case 81:
            case 182:
                palette = "Velocity256";
                break;
            
            case 154:
                palette = "SuperResolutionVelocity256";
                break;

            case 32:
            case 180:
            case 186:
                palette = "Reflectivity256";
                break;
            
            case 153:
                palette = "SuperResolutionReflectivity256";
                break;

            case 159:
                palette = "DifferentialReflectivity256";
                break;

            case 161:
                palette = "CorrelationCoefficient256";
                break;

            case 163:
                palette = "DifferentialPhase256";
                break;

            case 164:
                palette = "HydrometeorClassification16";
                break;

            case 165:
            case 177:
                palette = "HydrometeorClassification256";
                break;

            case 169:
                palette = "pal_169";
                break;

            case 170:
            case 172:
            case 173:
            case 176:
                palette = "PrecipAccumulation256";
                break;

            case 174:
            case 175:
                palette = "DifferentialAccum256";
                break;
        }
        return palette;
    },

    /**
     * Get the color palette for different radar data types.
     *
     * @method get_palette
     */
    get_palette: function () {
        if (this.palette) {
            return this.palette;
        }
        var data = this.get_data();
        var palette_name;
        if (data.src_id < 10000) { // NIDS products
            palette_name = this.get_palette_name_from_prod_code(data.prod_code);
            var pm = OCS.Viewer.Functions.get_palette_manager();
            return this.set_palette(pm.get_palette(palette_name));
        } else {
            console.warn(data.src_id, "Missing palette!");
        }
    },
    set_palette: function (palette) {
        if (palette && palette.class_type === "Palette" && palette.get_color_gradient().length && this.data_avail) {
            this.palette = palette;
        }
        return palette;
    },
    get_strm_tot_times: function () {
        var data = this.get_data();
        if (data.strm_tot_times) {
            return data.strm_tot_times;
        }
    },
    destroy: function () {
        if (this.active_timeout) {
            clearTimeout(this.active_timeout);
            this.active_timeout = null;
        }
        this.parent();
    }
});